import { filterSheetButton, menuBarButtonForm, quickFilterButton } from "../filtersheet/Selectors";
import { forEachElement } from "../util/Utils";
import type { TrackingLabels } from "./TrackingLabels";
import { mergeToLegacyLabel } from "./FeatureTracking";
import { Filter } from "../filter/Filter";
import tracker from "./Tracker";
import { SortingForm } from "../sorting/SortingForm";

const FACET_VALUE_TAG_FORM_SELECTOR = ".find_facetValueTags form";

export function trackInAllEvents<T extends keyof TrackingLabels>(label: T, value: TrackingLabels[T]) {
  tracker.addToPageImpression({
    [label]: value,
  });
  mergeLabel(filterSheetButton(), label, value);
  mergeLabel(quickFilterButton(), label, value);
  mergeLabel(menuBarButtonForm(), label, value);
  forEachElement(FACET_VALUE_TAG_FORM_SELECTOR, (elem) => mergeLabel(elem, label, value));
  Filter.factory.forEach((filter) => filter.mergeLabel(label, value));
  const sortingForm = SortingForm.template();
  if (sortingForm) {
    sortingForm.mergeLabel(label, value);
  }
}

export function mergeLabel<T extends keyof TrackingLabels>(
  element: HTMLElement | null,
  label: T,
  value: TrackingLabels[T],
) {
  if (element) {
    mergeToLegacyLabel(element, label, value);
  }
}
